import { SingleSubjectExtent } from './SingleSubjectExtent';
export default SingleSubjectExtent;
